export const DEFAULT_PROJECT_IMAGE = 'https://cdn.filestackcontent.com/resize=w:500/compress/dLXE4WC8S3mZFZNfClTK';
